(function($) {
	
	/*
	Modals
	 */
	
	$('.modal').detach().appendTo('body'); // fix z-index issues
	$('.modal').fitVids();
	
	$('.modal-open').on('click', function(e){
	    e.preventDefault();
	    $($(this).attr('href')).addClass('in');
	});
	$('.modal-close, .modal').on('click', function(e){
	    e.preventDefault();
	    closeModal();
	});

})( jQuery );